import { __, Alert } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtmlPuri from "draftjs-to-html";
import { convertToRaw, EditorState, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import APIManager from 'modules/common/apiManager';
import styled from 'styled-components'
import {
  Button,
  FormControl,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
} from 'modules/theme';
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';
const ResetCss = styled.div`
img{
  height:auto;
  width:auto;
  border-radius:0px;
}
// .public-DraftStyleDefault-ltr {
//   direction: ltr;
//   /* border: 2px solid black; */
//   text-align: left;
//   background: #FFFFFF;
//   box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
//   border-radius: 10px;
//   height: 100px;
//   width: 90%;
//   margin: 15px auto;
//   padding: 5px;
// }
.DraftEditor-root{
  z-index:0;
  direction: ltr;
  text-align: left;
  background: #FFFFFF;
  box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  border-radius: 10px;
  height: auto;
  width: 95%;
  min-height: 113px;
  margin: 15px auto;
  padding: 5px;
}
`;

class WhatsappSenderAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        wabaid: this.props.editData.wabaid,
        token: this.props.editData.token
       };
    } else {
      this.state = {
        wabaid: '',
        token: "",
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl style={{padding: 20}} {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
     wabaid: '',
     token: '',
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
    let wabaid = this.state.wabaid.trim();
    let token = this.state.token.trim();
    let tData = {
      token: token
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/wpSender/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`Whatsapp sender Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      tData.wabaid = wabaid;
      this.mAPI.sendPostAPI(
        'setting/wpSender',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  onEditorStateChange = editorState => {
    console.log(editorState)
    this.setState({ editorState });
  };

  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    console.log('infoData', this.props.infoData);
    return (
      <ModalForm onSubmit={e => this.saveData(e)}>
      <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Whatsapp Business Id', {
                placeholder:'Whatsapp Business Id',
                defaultValue: '',
                autoFocus: true,
                required: true,
                disabled: this.props.editData && this.props.editData._id ? true : false,
                id: 'wabaid',
                value: this.state.wabaid,
                onChange: e => {
                  this.setState({ wabaid: e.target.value });
                }
              })}
            </FormColumn>
          </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <ResetCss>

            <FormGroup>
           {/*  <ControlLabel>Templete</ControlLabel> */}
            {this.renderFormGroup('token', {
                placeholder:'',
                componentClass: 'textarea',
                defaultValue: '',
                autoFocus: this.props.editData && this.props.editData._id ? true : false,
                required: true,
                id: 'token',
                value: this.state.token,
                onChange: e => {
                  this.setState({ token: e.target.value });
                }
              })}
            </FormGroup>
          </ResetCss>
          </FormColumn>
        </FormWrapper>
        </ModalFormContainer>

        <ModalFooter modalType={modalType}>
          <Button
            className='grey-btn'
            btnStyle="cancel"
            onClick={() => this.props.closeModal()}
            size="xl"
            >
            Cancel
          </Button>
          <Button
            className="blue-btn"
            type="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Verify and Update' : 'Verify and Add'}
          </Button>
        </ModalFooter>
      </ModalForm>
    );
  }
}

WhatsappSenderAddEdit.propTypes = {
  group: PropTypes.array
};

WhatsappSenderAddEdit.contextTypes = {
  __: PropTypes.func
};

export default WhatsappSenderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppSender/components/WhatsappSenderAddEdit.js